<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <ng-container *ngIf="jobDetails; else showMessage">
    <!-- Sticky/Floating CTA Bar for public guest users -->
    <div class="public-sticky-cta-bar" [class.visible]="showStickyHeader" *ngIf="!isAuthenticated">
      <div class="sticky-cta-container">
        <div class="sticky-job-info">
          <span class="sticky-company-name">{{ jobDetails.company_name }}</span>
          <h2 class="sticky-job-title">{{ jobDetails.job_title }}</h2>
        </div>
        <div class="sticky-action-btn-wrap">
          <button (click)="redirectToHome()" class="public-apply-btn">
            Apply Job
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14"></path>
              <path d="M12 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="job-detail-workspace" *ngIf="jobDetails">
      <div class="job-detail-header">
        <div class="header-title-section">
          <button class="back-nav-btn" (click)="goBack()" title="Back to Jobs" *ngIf="isAuthenticated">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
          </button>
          <div class="title-meta-group">
            <p class="public-company-name" *ngIf="!isAuthenticated">
              {{ jobDetails.company_name }}
            </p>
            <div class="title-badge-row">
              <h1 class="job-title-text">{{ jobDetails.job_title }}</h1>
              <span class="status-pill-badge" [ngClass]="{
                  'active-pill': jobDetails.status.toLowerCase() === 'active',
                  'closed-pill':
                    jobDetails.status.toLowerCase() === 'closed' ||
                    jobDetails.status.toLowerCase() === 'rejected',
                  'pending-pill': jobDetails.status.toLowerCase() === 'pending',
                  'draft-pill': jobDetails.status.toLowerCase() === 'draft',
                }">
                {{ jobDetails.status }}
              </span>
            </div>
            <p class="created-subtitle-text">
              Created {{ jobDetails.created_at | date: "dd MMM yyyy" }}
            </p>
          </div>
        </div>

        <div class="public-actions" *ngIf="!isAuthenticated">
          <img src="assets/images/BeExpert-logo (2).svg" alt="BeExpert.ai" class="public-logo">
          <button (click)="redirectToHome()" class="public-apply-btn">
            Apply Job
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14"></path>
              <path d="M12 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>

        <div class="header-actions" *ngIf="isAuthenticated">
          <!-- <div class="visibility-toggle-box">
            <div class="toggle-label">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0z"
                />
                <circle cx="12" cy="12" r="3" />
              </svg>

              <span>
                {{
                  is_visible_on_bexpert
                    ? "Show on BeExpert"
                    : "Hidden from BeExpert"
                }}
              </span>
            </div>

            <label class="custom-switch">
              <input
                type="checkbox"
                [(ngModel)]="is_visible_on_bexpert"
                (click)="$event.preventDefault(); openVisibilityDialog()"
              />
              <span class="slider"></span>
            </label>
          </div> -->
          <!-- / -->

          <div class="visibility-wrapper">
            <div class="visibility-toggle-box">
              <div class="toggle-label">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <path
                    d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>

                <span>
                  {{
                  is_visible_on_bexpert
                  ? "Show on BeExpert.ai"
                  : "Hidden from BeExpert.ai"
                  }}
                </span>
              </div>

              <label class="custom-switch">
                <input type="checkbox" [checked]="is_visible_on_bexpert" (click)="toggleVisibilityPopup($event)" />
                <span class="slider"></span>
              </label>
            </div>

            <!-- Floating Popup -->
            <div class="visibility-inline-popup" *ngIf="showVisibilityPopup">
              <div class="popup-header">
                <div class="header-left">
                  <i class="fa-regular fa-eye"></i>
                  <span>Enable visibility on BeExpert.ai</span>
                </div>

                <button type="button" class="close-btn" (click)="showVisibilityPopup = false">
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>

              <div class="popup-body">
                <p>
                  Link an Assessment and an Interview to the BeExpert.ai platform.
                  Only then you can enable visibility on BeExpert.ai
                </p>

                <div class="status-card" *ngIf="jobDetails.screening_method !== 'ai_interview_only'">
                  <div class="status-left">
                    <i class="bi bi-file-earmark-text"></i>
                    <span>Assessment linked to BeExpert.ai</span>
                  </div>

                  <span class="status-badge" [class.linked]="isAssignAssessmentLinked">
                    {{ isAssignAssessmentLinked ? "Linked" : "Not linked" }}
                  </span>
                </div>

                <div class="status-card" *ngIf="jobDetails.screening_method !== 'assessment_only'">
                  <div class="status-left">
                    <i class="bi bi-camera-video"></i>
                    <span>Interview linked to BeExpert.ai</span>
                  </div>
                  <span class="status-badge" [class.linked]="isAssignInterviewLinked">
                    {{ isAssignInterviewLinked ? "Linked" : "Not linked" }}
                  </span>
                </div>
              </div>

              <div class="popup-footer gap-12">
                <button (click)="showVisibilityPopup = false" type="button" class="btn-cancel m-0">
                  Cancel
                </button>

                <button type="button" class="got-it-btn" (click)="openConfirmDialogBox()">
                  Got it
                </button>
              </div>
            </div>
          </div>
          <button *ngIf="
              jobDetails.status !== 'closed' &&
              jobDetails.status !== 'active' &&
              jobDetails.status !== 'rejected'
            " class="job-status-dropdown-btn" (click)="postCloseActiveJob()" [disabled]="isClosingJob">
            {{ isClosingJob ? "Closing..." : "Close Job" }}
          </button>
          <button *ngIf="jobDetails.status === 'draft'" class="submit" (click)="postSubmitDraftJob()"
            [disabled]="isSubmitDraftJob">
            {{ isSubmitDraftJob ? "Submitting..." : "Submit Job" }}
          </button>
        </div>
      </div>

      <!-- B2B Job Metrics Cards -->
      <div class="metrics-dashboard-grid" *ngIf="isAuthenticated">
        <div class="metric-block-card">
          <div class="block-left">
            <span class="metric-total-val">{{
              JobDetailStats?.applications || 0
              }}</span>
            <span class="metric-total-lbl">Applications</span>
          </div>
          <div class="block-icon-circle purple-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
            </svg>
          </div>
        </div>

        <div class="metric-block-card">
          <div class="block-left">
            <span class="metric-total-val">
              {{ JobDetailStats?.assessments_taken || 0 }}
            </span>
            <span class="metric-total-lbl">Assessments Taken</span>
          </div>
          <div class="block-icon-circle orange-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
          </div>
        </div>

        <div class="metric-block-card">
          <div class="block-left">
            <span class="metric-total-val">
              {{ JobDetailStats?.interviews_taken || 0 }}
            </span>
            <span class="metric-total-lbl">Interviews Taken</span>
          </div>
          <div class="block-icon-circle blue-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path
                d="M23 7a2 2 0 0 0-2.45-1.45L16 7V5a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2l4.55 1.45A2 2 0 0 0 23 17V7z" />
            </svg>
          </div>
        </div>

        <div class="metric-block-card">
          <div class="block-left">
            <span class="metric-total-val">
              {{ JobDetailStats?.shortlisted || 0 }}
            </span>
            <span class="metric-total-lbl">Shortlisted</span>
          </div>
          <div class="block-icon-circle green-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <polyline points="16 11 18 13 22 9" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Navigation Tab bar -->
      <div class="sub-tab-navigation-bar">
        <button class="tab-item-btn" [class.active]="activeSubTab === 'details'" (click)="setSubTab('details')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect width="18" height="18" x="3" y="3" rx="2" />
            <path d="M12 8h.01" />
            <path d="M12 12h.01" />
            <path d="M12 16h.01" />
            <path d="M8 8h.01" />
            <path d="M8 12h.01" />
            <path d="M8 16h.01" />
          </svg>
          Job Details
        </button>
        <button class="tab-item-btn" [class.active]="activeSubTab === 'assessment'" (click)="setSubTab('assessment')"
          *ngIf="jobDetails.screening_method !== 'ai_interview_only' && isAuthenticated">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
            <path d="m9 12 2 2 4-4" />
          </svg>
          Assessment
        </button>

        <button class="tab-item-btn" [class.active]="activeSubTab === 'interview'" (click)="setSubTab('interview')"
          *ngIf="jobDetails.screening_method !== 'assessment_only' && isAuthenticated">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path
              d="M23 7a2 2 0 0 0-2.45-1.45L16 7V5a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2l4.55 1.45A2 2 0 0 0 23 17V7z" />
          </svg>
          Interview
        </button>
         <ng-container *hasPermission="[PermissionForStudents.CANDIDATE_VIEW_FRESHER,
          PermissionForStudents.CANDIDATE_VIEW_EXPERIENCED,
          PermissionForStudents.CANDIDATE_VIEW_EDUCATOR]">
        <button class="tab-item-btn" [class.active]="activeSubTab === 'candidates'" (click)="setSubTab('candidates')"
          *ngIf="isAuthenticated">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
          </svg>
          Candidates
        </button>
        </ng-container> 
      </div>

      <div class="assessment-sub-tabs" *ngIf="activeSubTab === 'assessment'">
        <button class="sub-tab-btn" [class.active]="activeAssessmentTab === 'all assessment'"
          (click)="activeAssessmentTab = 'all assessment'" *ngIf="jobDetails.screening_method !== 'ai_interview_only'">
          All Assessment
        </button>

        <button class="sub-tab-btn" [class.active]="activeAssessmentTab === 'assign assessment'"
          (click)="activeAssessmentTab = 'assign assessment'"
          *ngIf="jobDetails.screening_method !== 'ai_interview_only'">
          Assign Assessment
        </button>
      </div>
      <!-- interview -->

      <div class="assessment-sub-tabs" *ngIf="activeSubTab === 'interview'">
        <button class="sub-tab-btn" [class.active]="activeInterviewTab === 'all interview'"
          (click)="activeInterviewTab = 'all interview'" *ngIf="jobDetails.screening_method !== 'assessment_only'">
          All Interview
        </button>

        <button class="sub-tab-btn" [class.active]="activeInterviewTab === 'assign interview'"
          (click)="activeInterviewTab = 'assign interview'" *ngIf="jobDetails.screening_method !== 'assessment_only'">
          Assign Interview
        </button>
      </div>

      <!-- TAB CONTENT SWITCHER -->
      <div class="tab-view-body-container">
        <!-- SUB-TAB 1: JOB DETAILS (READ-ONLY) -->
        <div class="sub-tab-panel" *ngIf="activeSubTab === 'details' && !isEditMode">
          <div class="view-block-card">
            <div class="block-card-header">
              <div class="title-left">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="18" height="18" x="3" y="3" rx="2" />
                  <path d="M8 12h8" />
                  <path d="M8 16h8" />
                  <path d="M8 8h8" />
                </svg>
                <h3>Basic Details</h3>
              </div>
              <button class="edit-detail-btn" (click)="startEdit()"
                *ngIf="jobDetails?.status !== 'closed' && isAuthenticated">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 20h9" />
                  <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
                </svg>
                Edit Job
              </button>
            </div>

            <div class="basic-details-fields-grid">
              <div class="field-item">
                <span class="field-lbl">Job Title</span>
                <span class="field-val font-semibold">{{
                  jobDetails.job_title || "-"
                  }}</span>
              </div>
              <div class="field-item">
                <span class="field-lbl">Category</span>
                <span class="field-val">{{
                  jobDetails.job_role_category || "-"
                  }}</span>
              </div>
              <div class="field-item">
                <span class="field-lbl">Job Type</span>
                <span class="field-val font-semibold">{{
                  jobDetails.job_type || "-"
                  }}</span>
              </div>
              <div class="field-item" *ngIf="
                  (jobDetails.job_type === 'Internship/Training' ||
                    jobDetails.job_type === 'Contract') &&
                  jobDetails.duration
                ">
                <span class="field-lbl">Duration</span>
                <span class="field-val font-semibold">{{ jobDetails.duration || "-" }}
                  {{ jobDetails.duration_unit || "-" }}</span>
              </div>
              <div class="field-item">
                <span class="field-lbl">Work Mode</span>
                <span class="field-val">{{ jobDetails.work_mode || "-" }}</span>
              </div>
              <ng-container *ngFor="let location of jobDetails.locations">
                <div class="field-item" *ngIf="location && location.trim()">
                  <span class="field-lbl">Location</span>
                  <span class="field-val">{{ location || "-" }}</span>
                </div>
              </ng-container>
              <div class="field-item">
                <span class="field-lbl">Status</span>
                <span class="status-badge-inline" [ngClass]="{
                    'active-badge':
                      jobDetails.status.toLowerCase() === 'active',
                    'closed-badge':
                      jobDetails.status.toLowerCase() === 'closed' ||
                      jobDetails.status.toLowerCase() === 'rejected',
                    'pending-badge':
                      jobDetails.status.toLowerCase() === 'pending',
                    'draft-badge': jobDetails.status.toLowerCase() === 'draft',
                  }">
                  {{ jobDetails.status }}
                </span>
              </div>
            </div>
          </div>

          <div class="view-block-card">
            <div class="block-card-header">
              <div class="title-left">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                  <polyline points="14 2 14 8 20 8" />
                </svg>
                <h3>Job Description</h3>
              </div>
            </div>

            <div class="description-section">
              <h4 class="sub-section-title">Description</h4>
              <p class="description-body-text">
                {{ jobDetails.description || "-" }}
              </p>

              <h4 class="sub-section-title">Roles & Responsibilities</h4>
              <ul class="bullet-list">
                <li>{{ jobDetails.roles_and_responsibilities || "-" }}</li>
              </ul>

              <div class="skills-wrapper-row">
                <div class="skills-block">
                  <span class="field-lbl">Required Skills </span>
                  <div class="skills-capsules">
                    <ng-container *ngIf="
                        jobDetails?.required_skills?.length;
                        else noRequiredSkills
                      ">
                      <span class="skill-tag" *ngFor="let skill of jobDetails.required_skills || []">{{ skill }}</span>
                    </ng-container>
                    <ng-template #noRequiredSkills>
                      <span class="field-val">-</span>
                    </ng-template>
                  </div>
                </div>
                <!-- <div class="skills-block">
                      <span class="field-lbl">Preferred Skills</span>
                      <div class="skills-capsules">
                        <span
                          class="skill-tag"
                          *ngFor="let skill of jobDetails.preferred_skills || []"
                          >{{ skill }}</span
                        >
                      </div>
                    </div> -->
              </div>
            </div>
          </div>

          <!-- Eligibility & Compensation Card -->
          <div class="view-block-card">
            <div class="block-card-header">
              <div class="title-left">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="16" x2="12" y2="12" />
                  <line x1="12" y1="8" x2="12.01" y2="8" />
                </svg>
                <h3>Eligibility & Compensation</h3>
              </div>
            </div>

            <div class="eligibility-fields-grid">
              <div class="eligibility-field span-full-width">
                <span class="field-lbl">Education</span>
                <div class="education-badge-capsules">
                  <ng-container *ngIf="jobDetails?.education?.length; else noEducation">
                    <span class="edu-tag" *ngFor="let edu of jobDetails.education || []">{{ edu }}</span>
                  </ng-container>
                  <ng-template #noEducation>
                    <span class="field-val">-</span>
                  </ng-template>
                </div>
              </div>
              <div class="eligibility-field">
                <span class="field-lbl">Minimum CGPA</span>
                <span class="field-val font-semibold">{{
                  jobDetails.min_cgpa || "-"
                  }}</span>
              </div>
              <div class="eligibility-field">
                <span class="field-lbl">Experience</span>
                <span class="field-val">{{
                  jobDetails.experience_level || "-"
                  }}</span>
              </div>
              <div class="eligibility-field span-full-width">
                <span class="field-lbl">Year of Passing</span>
                <div class="education-badge-capsules">
                  <ng-container *ngIf="jobDetails?.year_of_passing?.length; else noYear">
                    <span class="field-val" *ngFor="let year of jobDetails.year_of_passing">{{ year }}</span>
                  </ng-container>
                  <ng-template #noYear>
                    <span class="field-val">-</span>
                  </ng-template>
                </div>
              </div>
              <div class="eligibility-field">
                <span class="field-lbl">Openings</span>
                <span class="field-val">{{
                  jobDetails.number_of_openings || "0"
                  }}</span>
              </div>
              <div class="eligibility-field">
                <span class="field-lbl">Default Passing Score</span>
                <span class="field-val">{{ jobDetails.default_passing_score !== undefined ? jobDetails.default_passing_score + "%" : "40%" }}</span>
              </div>
              <div class="eligibility-field">
                <span class="field-lbl">Deadline</span>
                <span class="field-val highlight-deadline">{{
                  (jobDetails.application_deadline | date: "dd MMM yyyy") || "-"
                  }}</span>
              </div>
              <div class="eligibility-field">
                <span class="field-lbl">Salary / Stipend</span>
                <span class="field-val salary-text font-bold">{{ formatSalary(jobDetails.salary_min, jobDetails.salary_max, jobDetails.currency, jobDetails.payment_frequency) }}</span>
              </div>
              <div class="eligibility-field" *ngIf="jobDetails.job_type === 'Internship/Training' || jobDetails.expected_full_time_salary">
                <span class="field-lbl">Expected Full-Time Salary</span>
                <span class="field-val salary-text font-bold">{{ formatSalary(jobDetails.expected_full_time_salary, jobDetails.expected_full_time_salary, jobDetails.expected_full_time_salary_currency, jobDetails.expected_full_time_salary_frequency) }}</span>
              </div>
            </div>

            <div class="perks-block-bottom">
              <span class="field-lbl">Perks & Benefits</span>
              <div class="skills-capsules">
                <ng-container *ngIf="jobDetails?.perks_and_benefits?.length; else noPerks">
                  <span class="perk-tag" *ngFor="let perk of jobDetails.perks_and_benefits || []">{{ perk }}</span>
                </ng-container>
                <ng-template #noPerks>
                  <span class="field-val">-</span>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="view-block-card">
            <div class="block-card-header">
              <div class="title-left">
                <i class="bi bi-diagram-3"></i>
                <h3>Hiring Process</h3>
              </div>
            </div>
            <div class="eligibility-fields-grid">
              <div class="eligibility-field span-full-width"
                *ngFor="let step of jobDetails.hiring_process; let i = index">
                <span class="field-lbl process">Stage {{ i + 1 }}</span>
                <span class="field-val">{{ step || "-" }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- SUB-TAB 1: JOB DETAILS (EDIT MODE) -->
        <div class="sub-tab-panel edit-mode-container" *ngIf="activeSubTab === 'details' && isEditMode">
          <div class="view-block-card">
            <div class="block-card-header">
              <div class="title-left">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="18" height="18" x="3" y="3" rx="2" />
                  <path d="M8 12h8" />
                  <path d="M8 16h8" />
                  <path d="M8 8h8" />
                </svg>
                <h3>Basic Details</h3>
              </div>
              <div class="action-buttons-group">
                <button class="cancel-edit-btn" (click)="cancelEdit()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                  Cancel
                </button>
                <button class="save-edit-btn" (click)="saveEdit()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  Save
                </button>
              </div>
            </div>

            <div class="basic-details-fields-grid edit-grid-padding">
              <div class="field-item">
                <span class="field-lbl">Job Title</span>
                <input type="text" class="edit-input-field" [(ngModel)]="editForm.title" />
              </div>
              <div class="field-item">
                <span class="field-lbl">Job Role Category</span>
                <select class="edit-select-field" [(ngModel)]="editForm.category">
                  <option value="Teachers">Teachers</option>
                  <option value="Professors">Professors</option>
                  <option value="Trainers">Trainers</option>
                  <option value="Instructors">Instructors</option>
                  <option value="Coaches">Coaches</option>
                  <option value="Academic Mentors">Academic Mentors</option>
                </select>
              </div>
              <div class="field-item">
                <span class="field-lbl">Job Type</span>
                <div class="edit-radio-grid">
                  <label class="edit-radio-label">
                    <input type="radio" name="jobType" value="Full-Time" [(ngModel)]="editForm.type" (change)="onEditJobTypeChange(editForm.type)" />
                    <span>Full-Time</span>
                  </label>
                  <label class="edit-radio-label">
                    <input type="radio" name="jobType" value="Part-Time" [(ngModel)]="editForm.type" (change)="onEditJobTypeChange(editForm.type)" />
                    <span>Part-Time</span>
                  </label>
                  <label class="edit-radio-label">
                    <input type="radio" name="jobType" value="Internship/Training" [(ngModel)]="editForm.type" (change)="onEditJobTypeChange(editForm.type)" />
                    <span>Internship</span>
                  </label>
                  <label class="edit-radio-label">
                    <input type="radio" name="jobType" value="Contract" [(ngModel)]="editForm.type" (change)="onEditJobTypeChange(editForm.type)" />
                    <span>Contract</span>
                  </label>
                </div>
              </div>
              <div class="field-item">
                <span class="field-lbl">Work Mode</span>
                <div class="edit-radio-grid">
                  <label class="edit-radio-label">
                    <input type="radio" name="workMode" value="Onsite" [(ngModel)]="editForm.workMode" />
                    <span>Onsite</span>
                  </label>
                  <label class="edit-radio-label">
                    <input type="radio" name="workMode" value="Remote" [(ngModel)]="editForm.workMode" />
                    <span>Remote</span>
                  </label>
                  <label class="edit-radio-label">
                    <input type="radio" name="workMode" value="Hybrid" [(ngModel)]="editForm.workMode" />
                    <span>Hybrid</span>
                  </label>
                </div>
              </div>
              <div class="field-item">
                <span class="field-lbl">Location</span>
                <input type="text" class="edit-input-field" [(ngModel)]="editForm.location" />
              </div>
            </div>
          </div>

          <div class="view-block-card">
            <div class="block-card-header">
              <div class="title-left">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                  <polyline points="14 2 14 8 20 8" />
                </svg>
                <h3>Job Description</h3>
              </div>
            </div>

            <div class="description-section">
              <h4 class="sub-section-title">Detailed Job Description</h4>
              <div class="textarea-relative-wrapper">
                <textarea class="edit-textarea-field text-desc-height"
                  [(ngModel)]="editForm.descriptionText"></textarea>
                <svg class="textarea-edit-pen-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M12 20h9" />
                  <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
                </svg>
              </div>

              <h4 class="sub-section-title">Roles & Responsibilities</h4>
              <div class="textarea-relative-wrapper">
                <textarea class="edit-textarea-field text-roles-height" [(ngModel)]="editForm.rolesText"
                  placeholder="Enter each point on a new line"></textarea>
                <svg class="textarea-edit-pen-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M12 20h9" />
                  <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
                </svg>
              </div>

              <div class="skills-wrapper-row edit-skills-border">
                <div class="skills-block">
                  <span class="field-lbl">Required Skills</span>
                  <div class="skills-capsules edit-capsules-gap">
                    <span class="skill-tag edit-closeable-pill" *ngFor="
                        let skill of editForm.requiredSkills;
                        let i = index
                      ">
                      {{ skill }}
                      <button class="remove-pill-btn" (click)="removeRequiredSkill(i)">
                        &times;
                      </button>
                    </span>
                  </div>
                  <div class="add-skill-box">
                    <input type="text" class="add-skill-input" placeholder="Add skill"
                      [(ngModel)]="editForm.newRequiredSkill" (keyup.enter)="addRequiredSkill()" />
                    <button class="add-skill-btn" (click)="addRequiredSkill()">
                      Add
                    </button>
                  </div>
                </div>

                <div class="skills-block">
                  <span class="field-lbl">Preferred Skills</span>
                  <div class="skills-capsules edit-capsules-gap">
                    <span class="skill-tag edit-closeable-pill" *ngFor="
                        let skill of editForm.preferredSkills;
                        let i = index
                      ">
                      {{ skill }}
                      <button class="remove-pill-btn" (click)="removePreferredSkill(i)">
                        &times;
                      </button>
                    </span>
                  </div>
                  <div class="add-skill-box">
                    <input type="text" class="add-skill-input" placeholder="Add skill"
                      [(ngModel)]="editForm.newPreferredSkill" (keyup.enter)="addPreferredSkill()" />
                    <button class="add-skill-btn" (click)="addPreferredSkill()">
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="view-block-card">
            <div class="block-card-header">
              <div class="title-left">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="16" x2="12" y2="12" />
                  <line x1="12" y1="8" x2="12.01" y2="8" />
                </svg>
                <h3>Eligibility & Compensation</h3>
              </div>
            </div>

            <div class="eligibility-fields-grid edit-grid-padding">
              <div class="eligibility-field span-full-width">
                <span class="field-lbl">Education</span>
                <div class="education-matrix-pills">
                  <button type="button" class="matrix-pill-btn" *ngFor="let edu of allEducationOptions"
                    [class.active]="editForm.education.includes(edu)" (click)="toggleEducation(edu)">
                    {{ edu }}
                  </button>
                </div>
              </div>

              <div class="eligibility-field">
                <span class="field-lbl">Minimum CGPA</span>
                <input type="text" class="edit-input-field" [(ngModel)]="editForm.minCgpa" />
              </div>

              <div class="eligibility-field">
                <span class="field-lbl">Experience Level</span>
                <select class="edit-select-field" [(ngModel)]="editForm.experience">
                  <option value="Fresher">Fresher</option>
                  <option value="0-1 years">0-1 years</option>
                  <option value="1-3 years">1-3 years</option>
                  <option value="3+ years">3+ years</option>
                </select>
              </div>

              <div class="eligibility-field span-full-width">
                <span class="field-lbl">Year of Passing</span>
                <div class="years-matrix-pills">
                  <button type="button" class="matrix-pill-btn" *ngFor="let year of allYearPassingOptions"
                    [class.active]="editForm.yearPassing.includes(year)" (click)="toggleYearPassing(year)">
                    {{ year }}
                  </button>
                </div>
              </div>

              <div style="grid-column: 1 / -1; display: grid; gap: 1.5rem;" [ngStyle]="{'grid-template-columns': editForm.type === 'Internship/Training' ? '1fr 1fr' : '1fr'}">
                <div class="eligibility-field">
                <span class="field-lbl">Salary / Stipend</span>
                <div style="display: flex; gap: 6px; align-items: center;">
                  <select class="edit-select-field" [(ngModel)]="editForm.currency" name="currency" style="width: auto;">
                    <option value="₹">₹ (INR)</option>
                    <option value="$">$ (USD)</option>
                    <option value="€">€ (EUR)</option>
                    <option value="£">£ (GBP)</option>
                  </select>
                  <input type="text" placeholder="Min" class="edit-input-field" [(ngModel)]="editForm.salaryMin" name="salaryMin" style="flex: 1; min-width: 0;" />
                  <span class="font-bold text-sm text-gray-500 px-1">TO</span>
                  <input type="text" placeholder="Max" class="edit-input-field" [(ngModel)]="editForm.salaryMax" name="salaryMax" style="flex: 1; min-width: 0;" />
                  <select class="edit-select-field" [(ngModel)]="editForm.payment_frequency" name="payment_frequency" style="width: auto;">
                    <option value="LPA">LPA</option>
                    <option value="Per Year">Per Year</option>
                    <option value="Per Month">Per Month</option>
                    <option value="Per Hour">Per Hour</option>
                  </select>
                </div>
              </div>

              <div class="eligibility-field" *ngIf="editForm.type === 'Internship/Training'">
                <span class="field-lbl">Expected Full-Time Salary</span>
                <div style="display: flex; gap: 6px; align-items: center;">
                  <select class="edit-select-field" [(ngModel)]="editForm.expected_full_time_salary_currency" name="expected_full_time_salary_currency" style="width: auto;">
                    <option value="₹">₹ (INR)</option>
                    <option value="$">$ (USD)</option>
                    <option value="€">€ (EUR)</option>
                    <option value="£">£ (GBP)</option>
                  </select>
                  <input type="text" class="edit-input-field" [(ngModel)]="editForm.expectedFtSalary" name="expectedFtSalary" style="flex: 1; min-width: 0;" />
                  <select class="edit-select-field" [(ngModel)]="editForm.expected_full_time_salary_frequency" name="expected_full_time_salary_frequency" style="width: auto;">
                    <option value="LPA">LPA</option>
                    <option value="Per Year">Per Year</option>
                    <option value="Per Month">Per Month</option>
                    <option value="Per Hour">Per Hour</option>
                  </select>
                </div>
              </div>
              </div>

              <div style="grid-column: 1 / -1;"></div>
              <div class="eligibility-field">
                <span class="field-lbl">Number of Openings</span>
                <input type="number" class="edit-input-field" [(ngModel)]="editForm.openings" />
              </div>
              <div class="eligibility-field">
                <span class="field-lbl">Default Passing Score (%)</span>
                <input type="number" class="edit-input-field" [(ngModel)]="editForm.default_passing_score" min="1" max="100" />
              </div>
            </div>

            <div class="perks-block-bottom edit-perks-padding">
              <span class="field-lbl">Perks & Benefits</span>
              <div class="perks-matrix-pills">
                <button type="button" class="matrix-pill-btn" *ngFor="let perk of allPerksOptions"
                  [class.active]="editForm.perks.includes(perk)" (click)="togglePerk(perk)">
                  {{ perk }}
                </button>
              </div>
            </div>

            <div class="deadline-block-bottom">
              <span class="field-lbl">Application Deadline</span>
              <div class="edit-input-icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                  class="calendar-icon">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                <input type="text" class="edit-input-field icon-padding" [(ngModel)]="editForm.deadline" />
              </div>
            </div>
          </div>
        </div>

        <!-- SUB-TAB 2: ASSESSMENT -->
        <ng-container *ngIf="jobDetails.screening_method !== 'ai_interview_only'">
          <div class="sub-tab-panel" *ngIf="activeSubTab === 'assessment'">
            <div *ngIf="activeAssessmentTab === 'all assessment'">
              <div class="section-actions-row">
                <div class="section-title-left">
                  <h3>Assessments</h3>
                  <p>Assessments configured for this job</p>
                </div>
                <button class="primary-action-btn" (click)="onAddAssessmentClick()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                  Create Assessment
                </button>
              </div>

              <div class="configured-assessments-grid course-grid" *ngIf="assessments.length > 0">
                <div class="course-card" *ngFor="let assessment of assessments">
                  <div class="card-header-row">
                    <div class="left"></div>

                    <div class="card-top-right justify-content-between">
                      <div class="d-flex">
                        <span class="status" [ngClass]="assessment.status.toLowerCase()">
                          {{ assessment.status | titlecase }}
                        </span>

                        <span class="link ms-2" *ngIf="
                            assessment.status === 'Published' &&
                            assessment.links_count
                          ">
                          <i class="bi bi-link"></i>
                          {{ assessment.links_count }} Link
                        </span>

                        <span class="course-quiz ms-2" [ngClass]="{
                            course: assessment.mode === 'course_quiz',
                            assessment:
                              assessment.mode === 'proctored_assessment',
                          }">
                          {{ getQuizTypeLabel(assessment.mode || "") }}
                        </span>
                      </div>
                      <div class="menu-wrapper">
                        <button class="menu-btn" (click)="
                            toggleMenu(assessment.quiz_id);
                            $event.stopPropagation()
                          ">
                          <span class="material-icons">more_vert</span>
                        </button>

                        <div class="menu-dropdown" *ngIf="openMenuId === assessment.quiz_id">
                          <button class="menu-item" (click)="onEditQuiz(assessment)">
                            <i class="bi bi-pencil"></i> Edit
                          </button>

                          <button class="menu-item danger" (click)="onDeleteQuiz(assessment)">
                            <i class="bi bi-trash"></i> Delete
                          </button>

                          <button class="menu-item danger" (click)="onViewQuiz(assessment.quiz_id)">
                            <i class="bi bi-star"></i> Review
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-top">
                    <div class="left">
                      <div class="text">
                        <h3 class="truncate" [title]="assessment.quiz_name">
                          {{ assessment.quiz_name }}
                        </h3>
                        <p class="course-name m-0">
                          {{ assessment.course_title }}
                        </p>
                        <p class="course-des" [title]="assessment.description">
                          {{ truncateText(assessment.description || "", 100) }}
                        </p>
                        <div class="meta-info">
                          <div class="meta-item">
                            <i class="bi bi-question-circle me-2"></i>
                            <span>{{ assessment.questions?.length || 0 }} Q</span>
                          </div>

                          <div class="meta-item">
                            <i class="bi bi-clock me-2"></i>
                            <span>{{
                              assessment.time_limit
                              ? assessment.time_limit / 60
                              : 0
                              }}
                              min</span>
                          </div>

                          <div class="meta-item icon-link" *ngIf="
                              assessment.status === 'Published' &&
                              assessment.links_count
                            ">
                            <i class="bi bi-link"></i>
                            {{ assessment.links_count }} Link
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="divider"></div>
                  <button class="add-btn" type="button" *ngIf="assessment.status === 'Draft'"
                    (click)="changeQuizStatus(assessment.quiz_id)">
                    Publish & Generate Link
                  </button>

                  <div class="action-row">
                    <button class="action-tile" (click)="onViewQuiz(assessment.quiz_id)">
                      <i class="bi bi-pencil"></i>
                      <span>Edit Quiz</span>
                    </button>

                    <button class="action-tile" (click)="onViewQuiz(assessment.quiz_id)">
                      <i class="bi bi-eye"></i>
                      <span>View Questions</span>
                    </button>

                    <button class="action-tile" (click)="goToGenerativeDetailPage(assessment.quiz_id)">
                      <i class="bi bi-link-45deg"></i>
                      <span>View Links</span>
                      <p class="link-badge" *ngIf="assessment.links_count">
                        {{ assessment.links_count }}
                      </p>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Pagination Controls -->
              <div class="pagination-container" *ngIf="assessments.length > 0 && assessmentTotalPages > 1" style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 1rem;
                  margin-top: 1.5rem;
                ">
                <button class="secondary-action-btn" style="
                    padding: 0.5rem 1rem;
                    border-radius: 6px;
                    border: 1px solid #e2e8f0;
                    background: #fff;
                    cursor: pointer;
                    transition: all 0.2s;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                  " [disabled]="!assessmentHasPreviousPage" [ngStyle]="{
                    opacity: !assessmentHasPreviousPage ? '0.5' : '1',
                    cursor: !assessmentHasPreviousPage
                      ? 'not-allowed'
                      : 'pointer',
                  }" (click)="previousAssessmentPage()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                  Previous
                </button>

                <span style="font-size: 0.875rem; color: #475569; font-weight: 500">
                  Page {{ assessmentCurrentPage }} of {{ assessmentTotalPages }}
                </span>

                <button class="secondary-action-btn" style="
                    padding: 0.5rem 1rem;
                    border-radius: 6px;
                    border: 1px solid #e2e8f0;
                    background: #fff;
                    cursor: pointer;
                    transition: all 0.2s;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                  " [disabled]="!assessmentHasNextPage" [ngStyle]="{
                    opacity: !assessmentHasNextPage ? '0.5' : '1',
                    cursor: !assessmentHasNextPage ? 'not-allowed' : 'pointer',
                  }" (click)="nextAssessmentPage()">
                  Next
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>

              <div class="empty-state-container mt-4" *ngIf="assessments.length === 0">
                <div class="text-center p-5 border rounded bg-light">
                  <h4 class="text-muted fw-bold mt-3" style="color: #64748b">
                    No Assessments Found
                  </h4>
                  <p class="text-muted fs-small" style="color: #94a3b8">
                    Click "Create Assessment" to configure a new round.
                  </p>
                </div>
              </div>
            </div>

            <!-- new assign assessment -->
            <div *ngIf="activeAssessmentTab === 'assign assessment'">
              <div class="test">
                <div class="assessment-header-card">
                  <div class="assessment-info">
                    <div class="title-row">
                      <i class="fa-regular fa-file-lines"></i>
                      <h3>Assign Assessment on BeExpert.ai</h3>
                      <span class="info-icon">ⓘ</span>
                    </div>

                    <p>
                      This assigned assessment will be visible for candidates in
                      the BeExpert.ai platform.
                    </p>
                  </div>

                  <div class="assessment-actions">
                    <span class="status-badge" [class.linked]="isAssignAssessmentLinked">
                      {{
                      isAssignAssessmentLinked ? "Assigned" : "Not Assigned"
                      }}</span>

                    <ng-container *ngIf="isAssignAssessmentLinked; else showAssingBtn">
                      <button class="assign-btn" (click)="openAssessmentPopup()">
                        Change Assessment
                      </button>
                    </ng-container>
                    <ng-template #showAssingBtn>
                      <button class="assign-btn" (click)="openAssessmentPopup()">
                        Assign Assessment
                      </button>
                    </ng-template>
                  </div>
                  <div class="accordion-toggle" (click)="isAssessmentExpanded = !isAssessmentExpanded">
                    <i class="bi" [ngClass]="
                        isAssessmentExpanded
                          ? 'bi-chevron-up'
                          : 'bi-chevron-down'
                      "></i>
                  </div>
                </div>
                <!-- add new assingment dtaa -->
                <div *ngIf="isAssessmentExpanded">
                  <ng-container *ngIf="assignAssessments.length > 0; else showMessage">
                    <div class="configured-assessments-grid course-grid course-pading">
                      <div class="course-card" *ngFor="let assignAssessment of paginatedAssignAssessments">
                        <div class="card-header-row">
                          <div class="left"></div>

                          <div class="card-top-right justify-content-between">
                            <div class="d-flex">
                              <span class="status" [ngClass]="
                                  assignAssessment.status.toLowerCase()
                                ">
                                {{ assignAssessment.status | titlecase }}
                              </span>

                              <span class="link ms-2" *ngIf="assignAssessment.quiz_link_url">
                                <i class="bi bi-link"></i>
                                1 Link
                              </span>
                              <span class="course-quiz ms-2" [ngClass]="{
                                  course:
                                    assignAssessment.mode === 'course_quiz',
                                  assessment:
                                    assignAssessment.mode ===
                                    'proctored_assessment',
                                }">
                                {{
                                getQuizTypeLabel(assignAssessment.mode || "")
                                }}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="card-top">
                          <div class="left">
                            <div class="text">
                              <h3 class="truncate" [title]="assignAssessment.quiz_title">
                                {{ assignAssessment.quiz_title }}
                              </h3>
                              <p class="course-name m-0" style="opacity: 0; pointer-events: none; user-select: none;">
                                -
                              </p>
                              <p class="course-des" style="opacity: 0; pointer-events: none; user-select: none;">
                                -
                              </p>
                              <div class="meta-info">
                                <div class="meta-item">
                                  <i class="bi bi-question-circle me-2"></i>
                                  <span>{{ assignAssessment.questions_count ||
                                    getQuestionCount(assignAssessment.quiz_id) }} Q</span>
                                </div>

                                <div class="meta-item">
                                  <i class="bi bi-clock me-2"></i>
                                  <span>{{ getDuration(+assignAssessment.time_limit) }}</span>
                                </div>

                                <div class="meta-item icon-link" style="display: flex; align-items: center; gap: 4px;">
                                  <span class="link-label">URL</span>
                                  <i class="bi" [ngClass]="
                                      copiedId === assignAssessment.quiz_id
                                        ? 'bi-check-lg text-success'
                                        : 'bi-clipboard copy-icon'
                                    " (click)="
                                      copyToClipboard(
                                        assignAssessment.quiz_link_url,
                                        assignAssessment.quiz_id
                                      )
                                    " [matTooltip]="
                                      copiedId === assignAssessment.quiz_id
                                        ? 'Copied!'
                                        : 'Copy assessment URL'
                                    " matTooltipPosition="above" style="cursor: pointer;">
                                  </i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="divider"></div>

                        <div class="action-row">
                          <button class="action-tile" (click)="onViewQuiz(assignAssessment.quiz_id)">
                            <i class="bi bi-pencil"></i>
                            <span>Edit Quiz</span>
                          </button>

                          <button class="action-tile" (click)="onViewQuiz(assignAssessment.quiz_id)">
                            <i class="bi bi-eye"></i>
                            <span>View Questions</span>
                          </button>

                          <button class="action-tile" (click)="
                              goToGenerativeDetailPage(assignAssessment.quiz_id)
                            ">
                            <i class="bi bi-link-45deg"></i>
                            <span>View Links</span>
                            <p class="link-badge" *ngIf="assignAssessment.quiz_link_url">
                              1
                            </p>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Assign Assessment Pagination Controls -->
                    <div class="pagination-container"
                      *ngIf="assignAssessments.length > 0 && assignAssessmentTotalPages > 1" style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        gap: 1rem;
                        margin-top: 1.5rem;
                      ">
                      <button class="secondary-action-btn" style="
                          padding: 0.5rem 1rem;
                          border-radius: 6px;
                          border: 1px solid #e2e8f0;
                          background: #fff;
                          cursor: pointer;
                          transition: all 0.2s;
                          display: flex;
                          align-items: center;
                          gap: 0.5rem;
                        " [disabled]="!assignAssessmentHasPreviousPage" [ngStyle]="{
                          opacity: !assignAssessmentHasPreviousPage ? '0.5' : '1',
                          cursor: !assignAssessmentHasPreviousPage ? 'not-allowed' : 'pointer'
                        }" (click)="onAssignAssessmentPageChange(assignAssessmentCurrentPage - 1)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                        Previous
                      </button>

                      <span style="font-size: 0.875rem; color: #475569; font-weight: 500">
                        Page {{ assignAssessmentCurrentPage }} of {{ assignAssessmentTotalPages }}
                      </span>

                      <button class="secondary-action-btn" style="
                          padding: 0.5rem 1rem;
                          border-radius: 6px;
                          border: 1px solid #e2e8f0;
                          background: #fff;
                          cursor: pointer;
                          transition: all 0.2s;
                          display: flex;
                          align-items: center;
                          gap: 0.5rem;
                        " [disabled]="!assignAssessmentHasNextPage" [ngStyle]="{
                          opacity: !assignAssessmentHasNextPage ? '0.5' : '1',
                          cursor: !assignAssessmentHasNextPage ? 'not-allowed' : 'pointer'
                        }" (click)="onAssignAssessmentPageChange(assignAssessmentCurrentPage + 1)">
                        Next
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #showMessage>
                    <div class="assessment-empty-card">
                      <div class="empty-message">
                        No assessment is linked to BeExpert.ai yet. Use "Assign
                        Assessment" above to link one.
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!--  open assing popup-->
        <div class="popup-overlay" *ngIf="showAssessmentPopup">
          <div class="assessment-modal" (click)="$event.stopPropagation()">
            <div class="modal-header">
              <div class="header-left">
                <i class="fa-regular fa-file-lines"></i>
                <h3>Assign Assessment</h3>
              </div>

              <button type="button" class="close-btn" (click)="showAssessmentPopup = false">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>

            <div class="modal-body">
              <p class="description">
                This assigned assessment will be visible for candidates in the
                BeExpert.ai platform.
              </p>

              <div class="assessment-table">
                <div class="table-header">
                  <div>ASSESSMENT</div>
                  <div>STATUS</div>
                  <div>SELECT</div>
                </div>

                <div class="table-body-scroll">
                  <div class="table-row" *ngFor="let assessment of availableAssessments"
                    [class.active]="selectedAssessmentId === assessment.quiz_id">
                    <div class="assessment-info">
                      <div class="assessment-title">
                        {{ assessment.quiz_name || "-" }}
                      </div>

                      <div class="assessment-meta">
                        {{ assessment.questions?.length || 0 }} questions ·
                        {{ getDuration(assessment.time_limit) }}
                      </div>
                    </div>

                    <div>
                      <span class="status-pill" [class.linked]="isAssessmentAssigned(assessment.quiz_id)">
                        {{ isAssessmentAssigned(assessment.quiz_id) ? 'Assigned' : 'Not Assigned' }}
                      </span>
                    </div>

                    <div class="radio-cell">
                      <input type="radio" name="assessment" [value]="assessment.quiz_id"
                        [(ngModel)]="selectedAssessmentId" (change)="onAssessmentSelected(assessment)"
                        [disabled]="isAssessmentAssigned(assessment.quiz_id)" />
                    </div>
                    <div class="links-section" *ngIf="selectedAssessmentId === assessment.quiz_id">
                      <div class="active-links-section">
                        <div class="links-header">
                          Active Links — Select a link to assign
                        </div>

                        <div *ngIf="isLoadingLinks" class="text-center p-3">
                          Loading links...
                        </div>

                        <ng-container *ngIf="!isLoadingLinks">
                          <ng-container *ngIf="displayableAvailableLinks.length > 0; else noLinks">
                            <div class="links-scroll-area">
                              <div class="link-card mb-1" *ngFor="let link of displayableAvailableLinks">
                                <div class="link-left">
                                  <input type="radio" [name]="
                                      'linkSelection_' + assessment.quiz_id
                                    " [value]="link.link_id" [checked]="selectedLinkId === link.link_id"
                                    (change)="selectedLinkId = link.link_id"
                                    [disabled]="isLinkAssigned(link.link_id)" />

                                  <div class="link-details">
                                    <div class="link-title">
                                      {{ link.link_name || "Standard Link" }}
                                    </div>

                                    <div class="link-subtitle">
                                      {{ link.status?.toLowerCase() === 'expired' ? 'Expired on' : 'Active · Expires on'
                                      }}
                                      {{ link.end_date | date: "dd MMM yyyy" }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>

                          <ng-template #noLinks>
                            <div class="empty-links text-center py-4">
                              No active links available on this page.
                            </div>
                          </ng-template>
                        </ng-container>

                        <div class="table-pagination-footer" *ngIf="linkTotalPages > 1"
                          style="border-top: none; padding-top: 0.5rem; padding-bottom: 0;">
                          <span class="showing-txt">Page {{ linkCurrentPage }} of {{ linkTotalPages }}</span>
                          <div class="pagination-buttons">
                            <button type="button" class="pag-btn" [disabled]="linkCurrentPage === 1" (click)="
                              getAllSelectedAssessmentLink(
                                selectedQuizId,
                                jobId,
                                linkCurrentPage - 1
                              )
                            ">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="m15 18-6-6 6-6" />
                              </svg>
                            </button>
                            <button type="button" class="pag-btn active-page">{{ linkCurrentPage }}</button>
                            <button type="button" class="pag-btn" [disabled]="linkCurrentPage === linkTotalPages"
                              (click)="
                              getAllSelectedAssessmentLink(
                                selectedQuizId,
                                jobId,
                                linkCurrentPage + 1
                              )
                            ">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="m9 18 6-6-6-6" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="table-pagination-footer" *ngIf="assessmentTotalsPages > 1"
                  style="border-top: 1px solid #e2e8f0; margin-top: 1rem; padding-top: 1rem; padding-bottom: 0;">
                  <span class="showing-txt">Page {{ assessmentPage }} of {{ assessmentTotalsPages }}</span>
                  <div class="pagination-buttons">
                    <button type="button" class="pag-btn" [disabled]="assessmentPage === 1"
                      (click)="getAllQuiz(assessmentPage - 1)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="m15 18-6-6 6-6" />
                      </svg>
                    </button>
                    <button type="button" class="pag-btn active-page">{{ assessmentPage }}</button>
                    <button type="button" class="pag-btn" [disabled]="assessmentPage === assessmentTotalsPages"
                      (click)="getAllQuiz(assessmentPage + 1)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="m9 18 6-6-6-6" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="cancel-btn" (click)="showAssessmentPopup = false">
                Cancel
              </button>

              <button type="button" class="save-btn" [disabled]="
                  !selectedAssessmentId || !selectedLinkId || isAssignAssessment
                " (click)="assignAssessment()">
                <ng-container *ngIf="isLoading; else noAssign">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span> Assigning...</span>
                </ng-container>
                <ng-template #noAssign>
                  <span> Save Changes </span>
                </ng-template>
              </button>
            </div>
          </div>
        </div>
        <!-- SUB-TAB 3: INTERVIEW -->
        <ng-container *ngIf="jobDetails.screening_method !== 'assessment_only'">
          <div class="sub-tab-panel" *ngIf="activeSubTab === 'interview'">
            <div *ngIf="activeInterviewTab === 'all interview'">
              <div class="section-actions-row">
                <div class="section-title-left">
                  <h3>Interviews</h3>
                  <p>AI interviews configured for this job</p>
                </div>
                <button class="primary-action-btn" (click)="onAddInterviewClick()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                  Create Interview
                </button>
              </div>

              <div class="configured-assessments-grid" *ngIf="!isLoadingInterviews && interviews.length > 0">
                <div class="config-card-v2" *ngFor="let interview of interviews">
                  <div class="card-header-v2">
                    <span class="inline-pill" [ngClass]="
                        !isInterviewExpired(interview) &&
                        interview.status === 'active'
                          ? 'active-pill'
                          : 'pill-closed'
                      ">
                      {{
                      isInterviewExpired(interview)
                      ? "Expired"
                      : (interview.status | titlecase)
                      }}
                    </span>
                    <span class="department-lbl-v2">{{
                      interview.department
                      }}</span>
                  </div>

                  <div class="card-body-v2">
                    <h3 class="role-title-v2">{{ interview.job_role }}</h3>

                    <div class="skills-row-v2" *ngIf="interview.skills && interview.skills.length > 0">
                      <span class="skill-tag-v2" *ngFor="let skill of interview.skills | slice: 0 : 1">{{ skill
                        }}</span>
                      <span class="skill-tag-v2 extra-skill" *ngIf="interview.skills.length > 1">
                        +{{ interview.skills.length - 1 }}
                      </span>
                    </div>

                    <div class="meta-stats-grid-v2">
                      <span class="stat-item-v2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10" />
                          <polyline points="12 6 12 12 16 14" />
                        </svg>
                        {{ interview.total_duration_minutes }} min
                      </span>
                      <span class="stat-item-v2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                          <polyline points="22 4 12 14.01 9 11.01" />
                        </svg>
                        {{ interview.passing_score }}% pass
                      </span>
                      <span class="stat-item-v2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                          <circle cx="9" cy="7" r="4" />
                          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                        {{ interview.candidate_count }} candidates
                      </span>
                      <span class="stat-item-v2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                          <line x1="16" y1="2" x2="16" y2="6" />
                          <line x1="8" y1="2" x2="8" y2="6" />
                          <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                        {{ interview.valid_until | date: "MMM dd" }}
                      </span>
                    </div>
                  </div>

                  <div class="card-footer-v2">
                    <button class="config-card-action-btn-v2" (click)="onViewRoundDetails(interview.id)">
                      View Details
                    </button>
                  </div>
                </div>
              </div>

              <!-- Interview Pagination Controls -->
              <div class="table-pagination-footer" *ngIf="interviews.length > 0 && interviewTotalPages > 1"
                style="border-top: none; background: transparent; padding-bottom: 0;">
                <span class="showing-txt">Page {{ interviewCurrentPage }} of {{ interviewTotalPages }}</span>
                <div class="pagination-buttons">
                  <button type="button" class="pag-btn" [disabled]="!interviewHasPreviousPage"
                    (click)="onInterviewPageChange(interviewCurrentPage - 1)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="m15 18-6-6 6-6" />
                    </svg>
                  </button>
                  <button type="button" class="pag-btn active-page">{{ interviewCurrentPage }}</button>
                  <button type="button" class="pag-btn" [disabled]="!interviewHasNextPage"
                    (click)="onInterviewPageChange(interviewCurrentPage + 1)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="m9 18 6-6-6-6" />
                    </svg>
                  </button>
                </div>
              </div>

              <div class="empty-state-container mt-4" *ngIf="!isLoadingInterviews && interviews.length === 0">
                <div class="d-flex flex-column align-items-center justify-content-center text-center p-5 border rounded bg-light" style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                    stroke="#CBD5E1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mb-3">
                    <path
                      d="M23 7a2 2 0 0 0-2.45-1.45L16 7V5a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2l4.55 1.45A2 2 0 0 0 23 17V7z" />
                  </svg>
                  <h4 class="text-muted fw-bold mt-3" style="color: #64748b">
                    No Screening Rounds Found
                  </h4>
                  <p class="text-muted fs-small" style="color: #94a3b8">
                    Click "Create Interview" to configure a new AI screening
                    round.
                  </p>
                </div>
              </div>

              <div class="loading-state-container mt-4 text-center p-5" *ngIf="isLoadingInterviews">
                <p class="text-muted fw-bold" style="color: #64748b">
                  Loading Interviews...
                </p>
              </div>
            </div>

            <!--  assign interview-->
            <div *ngIf="activeInterviewTab === 'assign interview'">
              <div class="test">
                <div class="assessment-header-card">
                  <div class="assessment-info">
                    <div class="title-row">
                      <i class="fa-regular fa-file-lines"></i>
                      <h3>Assign Interview on BeExpert.ai</h3>
                      <span class="info-icon">ⓘ</span>
                    </div>

                    <p>
                      This assigned interview will be visible for candidates in
                      the BeExpert.ai platform.
                    </p>
                  </div>

                  <div class="assessment-actions">
                    <span class="status-badge" [class.linked]="isAssignInterviewLinked">
                      {{
                      isAssignInterviewLinked ? "Assigned" : "Not Assigned"
                      }}</span>

                    <ng-container *ngIf="isAssignInterviewLinked; else showAssignInterview">
                      <button class="assign-btn" (click)="openInterviewPopup()">
                        Change Interview
                      </button>
                    </ng-container>

                    <ng-template #showAssignInterview>
                      <button class="assign-btn" (click)="openInterviewPopup()">
                        Assign Interview
                      </button>
                    </ng-template>
                  </div>
                  <div class="accordion-toggle" (click)="isinterviewExpanded = !isinterviewExpanded">
                    <i class="bi" [ngClass]="
                        isinterviewExpanded
                          ? 'bi-chevron-up'
                          : 'bi-chevron-down'
                      "></i>
                  </div>
                </div>
                <!-- add new assing interview dtaa -->
                <div *ngIf="isinterviewExpanded">
                  <ng-container *ngIf="
                      assignInterviews.length > 0;
                      else showInterviewMessage
                    ">
                    <div class="configured-assessments-grid">
                      <div class="config-card-v2" *ngFor="let assignInterview of paginatedAssignInterviews">
                        <div class="card-header-v2">
                          <span class="inline-pill" [ngClass]="
                              !isAssignInterviewExpired(assignInterview) &&
                              assignInterview.status.toLowerCase() === 'active'
                                ? 'active-pill'
                                : 'pill-closed'
                            ">
                            {{
                            isAssignInterviewExpired(assignInterview)
                            ? "Expired"
                            : (assignInterview.status | titlecase)
                            }}
                          </span>
                          <span class="department-lbl-v2">AI Interview</span>
                        </div>

                        <div class="card-body-v2">
                          <h3 class="role-title-v2">{{ assignInterview.job_role || "-" }}</h3>

                          <div class="meta-stats-grid-v2">
                            <span class="stat-item-v2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <polyline points="12 6 12 12 16 14" />
                              </svg>
                              {{ assignInterview.total_duration_minutes || "0" }} min
                            </span>

                            <span class="stat-item-v2" *ngIf="assignInterview.interview_url">
                              <i class="bi bi-link"></i> 1 Link
                            </span>

                            <span class="stat-item-v2">
                              <div style="display: flex; align-items: center; gap: 4px;">
                                <span class="link-label">URL</span>
                                <i class="bi" [ngClass]="
                                    copiedId === assignInterview.screening_round_id
                                      ? 'bi-check-lg text-success'
                                      : 'bi-clipboard copy-icon'
                                  " (click)="
                                    copyToClipboard(
                                      assignInterview.interview_url,
                                      assignInterview.screening_round_id
                                    )
                                  " [matTooltip]="
                                    copiedId === assignInterview.screening_round_id
                                      ? 'Copied!'
                                      : 'Copy Interview URL'
                                  " matTooltipPosition="above" style="cursor: pointer;">
                                </i>
                              </div>
                            </span>
                          </div>
                        </div>

                        <div class="card-footer-v2">
                          <button class="config-card-action-btn-v2" (click)="
                              onViewRoundDetails(
                                assignInterview.screening_round_id
                              )
                            ">
                            View Details
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Assign Interview Pagination Controls -->
                    <div class="table-pagination-footer"
                      *ngIf="assignInterviews.length > 0 && assignInterviewTotalPages > 1"
                      style="border-top: none; background: transparent; padding-bottom: 0;">
                      <span class="showing-txt">Page {{ assignInterviewCurrentPage }} of {{ assignInterviewTotalPages
                        }}</span>
                      <div class="pagination-buttons">
                        <button type="button" class="pag-btn" [disabled]="!assignInterviewHasPreviousPage"
                          (click)="onAssignInterviewPageChange(assignInterviewCurrentPage - 1)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="m15 18-6-6 6-6" />
                          </svg>
                        </button>
                        <button type="button" class="pag-btn active-page">{{ assignInterviewCurrentPage }}</button>
                        <button type="button" class="pag-btn" [disabled]="!assignInterviewHasNextPage"
                          (click)="onAssignInterviewPageChange(assignInterviewCurrentPage + 1)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="m9 18 6-6-6-6" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #showInterviewMessage>
                    <div class="assessment-empty-card">
                      <div class="empty-message">
                        No interview is linked to BeExpert.ai yet. Use "Assign
                        interview" above to link one.
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <!--  open interview popup-->
        <div class="popup-overlay" *ngIf="showInterviewPopup">
          <div class="assessment-modal" (click)="$event.stopPropagation()">
            <div class="modal-header">
              <div class="header-left">
                <i class="fa-regular fa-file-lines"></i>
                <h3>Assign Interview</h3>
              </div>

              <button type="button" class="close-btn" (click)="showInterviewPopup = false">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>

            <div class="modal-body">
              <p class="description">
                This assigned interview will be visible for candidates in the
                BeExpert.ai platform.
              </p>

              <div class="assessment-table">
                <div class="links-section p-3">
                  <div class="active-links-section">
                    <div class="links-header mb-3">
                      Active Rounds — Select a round to assign
                    </div>

                    <div *ngIf="isLoadingInterview" class="text-center p-3">
                      Loading Rounds...
                    </div>

                    <ng-container *ngIf="!isLoadingInterview">
                      <ng-container *ngIf="displayableAvailableRounds.length > 0; else noRounds">
                        <div class="links-scroll-area">
                          <div class="link-card mb-2" *ngFor="let round of displayableAvailableRounds">
                            <div class="link-left">
                              <input type="radio" [name]="'roundSelection'" [value]="round.id"
                                [checked]="selectedRoundId === round.id" (change)="selectedRoundId = round.id"
                                [disabled]="isInterviewRoundAssigned(round.id)" />

                              <div class="link-details ms-2">
                                <div class="link-title fw-bold">
                                  {{ round.job_role }}
                                </div>

                                <div class="link-subtitle text-muted fs-small">
                                  {{ isInterviewExpired(round) ? 'Expired on' : 'Active · Expires on' }}
                                  {{
                                  round.valid_until | date: "dd MMM yyyy"
                                  }}
                                  <span *ngIf="isInterviewRoundAssigned(round.id)"
                                    class="text-primary ms-1 fw-bold">(Assigned)</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <ng-template #noRounds>
                        <div class="empty-links text-center py-4">
                          No active rounds available on this page.
                        </div>
                      </ng-template>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="cancel-btn" (click)="showInterviewPopup = false">
                Cancel
              </button>

              <button type="button" class="save-btn" [disabled]="
                  !selectedInterviewId || !selectedRoundId || isAssignInterviews
                " (click)="assignInterview()">
                <ng-container *ngIf="isLoading; else noAssign">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span> Assigning...</span>
                </ng-container>
                <ng-template #noAssign>
                  <span> Save Changes </span>
                </ng-template>
              </button>
            </div>
          </div>
        </div>
        <!--  -->

        <!-- SUB-TAB 4: CANDIDATES -->
          <ng-container *hasPermission="[PermissionForStudents.CANDIDATE_VIEW_FRESHER,
          PermissionForStudents.CANDIDATE_VIEW_EXPERIENCED,
          PermissionForStudents.CANDIDATE_VIEW_EDUCATOR]">  

        <div class="sub-tab-panel" *ngIf="activeSubTab === 'candidates'">
          <div class="candidates-header">
            <div class="candidates-applied-headline-row">
              <h3>Candidates Applied ({{ totalCandidates }})</h3>
            </div>

            <button class="btn-download" (click)="downloadUserData()">
              <i class="bi bi-download me-1"></i>
              Download Excel
            </button>
          </div>

          <!-- Inner switcher tab -->
          <div class="inner-experience-switcher">
            <ng-container *hasPermission="PermissionForStudents.CANDIDATE_VIEW_FRESHER">
            <button class="switcher-btn" [class.active]="candidateExperienceFilter === 'fresher'"
              (click)="switchCandidateTab('fresher')">
              Fresher
            </button>
            </ng-container>

            <ng-container *hasPermission="PermissionForStudents.CANDIDATE_VIEW_EXPERIENCED">
            <button class="switcher-btn" [class.active]="candidateExperienceFilter === 'experienced'"
              (click)="switchCandidateTab('experienced')">
              Experienced
            </button>
            </ng-container>

            <ng-container *hasPermission="PermissionForStudents.CANDIDATE_VIEW_EDUCATOR">
            <button class="switcher-btn" [class.active]="candidateExperienceFilter === 'educator'"
              (click)="switchCandidateTab('educator')">
              Candidates
            </button>
            </ng-container>
            <!-- <button class="switcher-btn" [class.active]="candidateExperienceFilter === 'educator'">Candidates</button> -->
          </div>

          <!-- Filter bar -->
          <div class="filters-bar">
            <div class="search-input-group">
              <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input type="text" placeholder="Search candidates..." [(ngModel)]="candidateSearchQuery"
                (ngModelChange)="onSearchChange()" />
            </div>
          </div>

          <!-- Candidates list table inside job details -->
          <div class="grid-card">
            <div class="table-container">
                <div class="table-scroll">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Timestamp</th>
                    <th>Email</th>
                    <th>Resume</th>
                    <th>Candidate Name</th>
                    <th>Job</th>
                    <th>Mobile</th>
                    <th>Subject</th>
                    <th>Goal</th>
                    <th>Exp (Yrs)</th>
                    <th>Current CTC (L)</th>
                    <th>Expected CTC (L)</th>
                    <th>Previous Institute</th>
                    <th>City 1</th>
                    <th>City 2</th>
                    <th>City 3</th>
                    <th class="center-align">Latest Assessment Score</th>
                    <th class="center-align">Latest AI Interview Score</th>
                    <!--<th>Status</th>-->
                    <th class="center-align">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let candidate of allCandidates; let i = index">
                    <td>{{ (currentPage - 1) * limit + i + 1 }}</td>
                    <td class="time">
                      {{ candidate.created_at | date: "dd MMM yyy" }}
                    </td>
                    <td>
                      <div class="candidate-meta-cell">
                        <span class="candidate-email">{{
                          candidate.email || "-"
                          }}</span>
                      </div>
                    </td>
                    <td class="center-align">
                      <button class="icon-btn-resume" title="Download Resume"
                        (click)="downloadResume(candidate.resume_url || '')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"
                          class="file-text-icon">
                          <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                          <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                          <path d="M10 9H8" />
                          <path d="M16 13H8" />
                          <path d="M16 17H8" />
                        </svg>
                        <span class="btn-lbl-txt">Resume</span>
                      </button>
                    </td>
                    <td [title]="candidate.name || ''">
                      {{
                      candidate.name && candidate.name.length > 10
                      ? (candidate.name | slice: 0 : 10) + "..."
                      : candidate.name || "-"
                      }}
                    </td>
                    <td>{{ candidate.job_title || "-" }}</td>
                    <td>{{ candidate.mobile }}</td>
                    <td class="font-semibold" [title]="candidate.subject || ''">
                      {{
                      candidate.subject && candidate.subject.length > 10
                      ? (candidate.subject | slice: 0 : 10) + "..."
                      : candidate.subject || "-"
                      }}
                    </td>
                    <td [title]="candidate.subject_specialization || ''">
                      {{
                      candidate.subject_specialization &&
                      candidate.subject_specialization.length > 10
                      ? (candidate.subject_specialization | slice: 0 : 10) +
                      "..."
                      : candidate.subject_specialization || "-"
                      }}
                    </td>
                    <td>{{ candidate.experience_years || "—" }}</td>
                    <td>{{ candidate.current_ctc || "—" }}</td>
                    <td>{{ candidate.expected_ctc || "—" }}</td>
                    <td [title]="candidate.previous_institute || ''">
                      {{
                      candidate.previous_institute &&
                      candidate.previous_institute.length > 10
                      ? (candidate.previous_institute | slice: 0 : 10) +
                      "..."
                      : candidate.previous_institute || "—"
                      }}
                    </td>
                    <td>{{ candidate.city_pref_1 || "—" }}</td>
                    <td>{{ candidate.city_pref_2 || "—" }}</td>
                    <td>{{ candidate.city_pref_3 || "—" }}</td>
                    <td class="center-align">
                      <span class="score-badge">
                        {{ candidate.assessment_score || "0" }}%
                      </span>
                    </td>
                    <td class="center-align">
                      <span class="score-badge">
                        {{ candidate.ai_interview_score || "0" }}%
                      </span>
                    </td>
                    <!--<td>
                      <span class="status-pills" [ngClass]="getStatusClass(candidate.status)">
                        {{ getStatusLabel(candidate.status) }}
                      </span>
                    </td>-->
                    <td class="center-align">
                      <button class="view-round-btn" title="View Details"
                        (click)="goToDetailPage(candidate.candidate_id)">
                        <i class="bi bi-eye"></i>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="!allCandidates.length">
                    <td colspan="10" class="empty-state-cell">
                      No candidates founds.
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
              <div class="table-pagination-footer">
                <span class="showing-txt">Showing
                  {{
                  allCandidates.length ? (currentPage - 1) * limit + 1 : 0
                  }}-{{ (currentPage - 1) * limit + allCandidates.length }} of
                  {{ totalCandidates }}</span>
                <div class="pagination-buttons">
                  <button type="button" class="pag-btn" [disabled]="!hasPreviousPage" (click)="previousPage()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="m15 18-6-6 6-6" />
                    </svg>
                  </button>
                  <button type="button" class="pag-btn active-page">{{ currentPage }}</button>
                  <button type="button" class="pag-btn" [disabled]="!hasNextPage" (click)="nextPage()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="m9 18 6-6-6-6" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
       </ng-container> 
      </div>
    </div>

    <div class="modal-backdrop-blur" *ngIf="showAddInterviewModal">
      <div class="modal-window-card custom-large-modal">
        <div class="modal-header-simple">
          <div>
            <h2 class="modal-heading-text">Create Screening Round</h2>
            <p class="modal-subheading-text">
              Configure an AI-powered interview round. Candidates can be invited
              after creation.
            </p>
          </div>
          <button class="close-btn-ghost" (click)="showAddInterviewModal = false">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="#64748B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div class="modal-body-scrollable p-4">
          <div class="grid-2-col mb-4">
            <div class="form-group">
              <label class="fw-bold fs-small">Job Role *</label>
              <div class="select-wrapper mt-2" *ngIf="!isCustomRole">
                <select class="form-control-input" [(ngModel)]="selectedRole" (change)="checkCustomRole()">
                  <option value="null">Select Role</option>
                  <option *ngFor="let role of availableRoles" [value]="role">
                    {{ role }}
                  </option>
                  <option value="custom" class="fw-bold text-primary">
                    + Add New Role
                  </option>
                </select>
              </div>
              <div class="input-icon-wrapper mt-2" *ngIf="isCustomRole">
                <input type="text" class="form-control-input" placeholder="Enter custom role"
                  [(ngModel)]="selectedRole" />
                <button class="close-btn-ghost position-absolute end-0 top-50 translate-middle-y me-1"
                  (click)="cancelCustomRole()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="#64748B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
            <div class="form-group">
              <label class="fw-bold fs-small">Department *</label>
              <div class="select-wrapper mt-2" *ngIf="!isCustomDept">
                <select class="form-control-input" [(ngModel)]="selectedDept" (change)="checkCustomDept()">
                  <option value="">Select Department</option>
                  <option *ngFor="let dept of availableDepartments" [value]="dept">
                    {{ dept }}
                  </option>
                  <option value="custom" class="fw-bold text-primary">
                    + Add New Department
                  </option>
                </select>
              </div>
              <div class="input-icon-wrapper mt-2" *ngIf="isCustomDept">
                <input type="text" class="form-control-input" placeholder="Enter custom department"
                  [(ngModel)]="selectedDept" />
                <button class="close-btn-ghost position-absolute end-0 top-50 translate-middle-y me-1"
                  (click)="cancelCustomDept()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="#64748B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div class="grid-2-col mb-4">
            <div class="form-group">
              <label class="fw-bold fs-small">Experience Required *</label>
              <div class="select-wrapper mt-2">
                <select class="form-control-input" [(ngModel)]="newInterviewForm.experience">
                  <option value=""></option>
                  <option value="Fresher">Fresher (0 years)</option>
                  <option value="1-3 Years">1-3 Years</option>
                  <option value="3-5 Years">3-5 Years</option>
                  <option value="5-8 Years">5-8 Years</option>
                  <option value="8-10 Years">8-10 Years</option>
                  <option value="10+ Years">10+ Years</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label class="fw-bold fs-small">Interview End Date</label>
              <div class="input-icon-wrapper mt-2">
                <svg class="left-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                  fill="none" stroke="#94A3B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <input type="date" name="valid_until" class="form-control-input with-icon"
                  [(ngModel)]="newInterviewForm.valid_until" #validUntil="ngModel" [min]="minDate" required />
              </div>
              <div *ngIf="
                  validUntil.invalid && (validUntil.dirty || validUntil.touched)
                " class="error-msg">
                Interview End Date is required.
              </div>
            </div>
          </div>

          <div class="grid-2-col mb-4">
            <div class="form-group">
              <label class="fw-bold fs-small">Interview Duration</label>
              <div class="select-wrapper mt-2">
                <select class="form-control-input" name="interviewDuration"
                  [(ngModel)]="newInterviewForm.total_duration_minutes" #durationCtrl="ngModel" required>
                  <option value="" disabled selected>
                    Select duration (in mins)
                  </option>
                  <option value="15">15 min</option>
                  <option value="30">30 min</option>
                  <option value="60">60 min</option>
                </select>
                <div *ngIf="
                    durationCtrl.invalid &&
                    (durationCtrl.dirty || durationCtrl.touched)
                  " class="error-msg">
                  Interview Duration is required.
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="fw-bold fs-small">Passing Score (%)</label>
              <input type="number" class="form-control-input mt-2" placeholder="e.g. 70" name="passingScore"
                [(ngModel)]="newInterviewForm.passing_score" #scoreCtrl="ngModel" required />
              <div *ngIf="
                  scoreCtrl.invalid && (scoreCtrl.dirty || scoreCtrl.touched)
                " class="error-msg">
                Passing Score is required.
              </div>
            </div>
          </div>

          <div class="grid-2-col mb-4">
            <div class="form-group">
              <label class="fw-bold fs-small">No of Attempts *</label>
              <input type="number" class="form-control-input mt-2" placeholder="Max limit is 10" name="maximumAttempts"
                [(ngModel)]="newInterviewForm.maximum_attempts" #attemptsCtrl="ngModel" required min="1" max="10" />
              <div *ngIf="
                  attemptsCtrl.invalid &&
                  (attemptsCtrl.dirty || attemptsCtrl.touched)
                " class="error-msg">
                No of Attempts is required and must be between 1 and 10.
              </div>
            </div>
          </div>

          <div class="educator-toggle-card mb-2" style="flex-direction: column; align-items: stretch; gap: 0.75rem;">
            <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
              <div>
                <h4 class="fw-bold fs-small m-0 text-dark">Enable Multi-language Support</h4>
              </div>
              <label class="toggle-switch">
                <input type="checkbox" [(ngModel)]="newInterviewForm.enable_multilanguage" />
                <span class="slider round"></span>
              </label>
            </div>
            <div style="font-size: 0.75rem; color: #64748b; line-height: 1.4;">
              <ul style="margin: 0; padding-left: 1.2rem;">
                <li>When enabled, the AI interviewer can understand, ask questions, and respond in the candidate's
                  selected language.</li>
                <li>Supported languages: {{ supportedLanguageNames }}.</li>
                <li>Evaluation reports will always be generated in English.</li>
              </ul>
            </div>
          </div>

          <div class="form-group mb-4">
            <label class="fw-bold fs-small">Job Description *</label>
            <textarea class="form-control-textarea mt-2" rows="3"
              placeholder="Describe the role, responsibilities and impact..."
              [(ngModel)]="newInterviewForm.job_description"></textarea>
          </div>

          <div class="form-group mb-4">
            <label class="fw-bold fs-small">Questions *</label>
            <textarea class="form-control-textarea mt-2" rows="8"
              placeholder="Enter each question on a new line, e.g.&#10;Walk us through a recent project&#10;Explain a system you designed"
              [(ngModel)]="newInterviewForm.questions" #questionsCtrl="ngModel" required></textarea>
            <div *ngIf="
                questionsCtrl.invalid &&
                (questionsCtrl.dirty || questionsCtrl.touched)
              " class="error-msg">
              Questions are required.
            </div>
            <span class="help-text-muted">Enter each question on a new line. For educator roles, toggle the
              Teacher Role switch above to auto-fill the standard question
              set.</span>
          </div>

          <div class="form-group mb-4">
            <label class="fw-bold fs-small">Skills *</label>
            <input type="text" class="form-control-input mt-2" placeholder="React, TypeScript, System Design"
              [(ngModel)]="skillsString" />
            <span class="help-text-muted">Comma-separated skill tags.</span>
          </div>

          <div class="educator-toggle-card mb-2">
            <div>
              <h4 class="fw-bold fs-small m-0 text-dark">Educator</h4>
              <p class="help-text-muted m-0">
                Enable if this role is for an Educator position.
              </p>
            </div>
            <label class="toggle-switch">
              <input type="checkbox" [(ngModel)]="newInterviewForm.is_teacher_role" (change)="onTeacherRoleToggle()" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <div class="modal-footer-flex">
          <button class="btn-outline-ghost" (click)="showAddInterviewModal = false" [disabled]="isCreatingInterview">
            Cancel
          </button>
          <button class="btn-primary-purple-gradient" (click)="createInterview()"
            [disabled]="isCreatingInterview || !isCreateInterviewFormValid" [ngStyle]="{
              opacity:
                !isCreateInterviewFormValid || isCreatingInterview
                  ? '0.6'
                  : '1',
              cursor:
                !isCreateInterviewFormValid || isCreatingInterview
                  ? 'not-allowed'
                  : 'pointer',
            }">
            {{ isCreatingInterview ? "Creating..." : "Create" }}
          </button>
        </div>
      </div>
    </div>

    <app-add-assessment-modal *ngIf="showAddAssessmentModal" [initialStep]="'create_new'"
      (closeModal)="showAddAssessmentModal = false">
    </app-add-assessment-modal>
  </ng-container>
  <ng-template #showMessage>
    <p class="text-center">No data available</p>
  </ng-template>
</ng-template>